import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Button from '../../../Button';
import Avatar from '../../../Avatar';
import Icon from '../../../Icon';
import defaultBanner from '../../../../assets/images/community-wallpaper.png';

import styles from './index.styl';

const VerticalCard = ({
  banner,
  logo,
  name,
  organization,
  totalPosts,
  totalUsers,
  onClick,
  joinCommunity,
  buttonInfo,
}) => (
  <li styleName="card">
    <div styleName="wrapper">
      <div
        styleName="header"
        onClick={onClick}
        style={{
          backgroundImage: `url(${banner || defaultBanner})`,
        }}
        role="presentation"
      >
        <div styleName="avatar">
          <Avatar
            children={name}
            src={logo}
            size={100}
            bordered
            position="center"
            sizePercent
            noTransparent
            rootStyle={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          />
        </div>
      </div>
      <div styleName="content" onClick={onClick} role="presentation">
        <div styleName="title">{name}</div>
        <div styleName="subtitle">{organization}</div>
      </div>
      <div styleName="footer">
        <div styleName="subtitle">
          <Icon
            name="icon-members"
            height="7%"
            width="5%"
            className="mr1"
            style={{ minWidth: 12, minHeight: 12 }}
          />
          <span className="mr1">{totalUsers}</span>
          <Icon
            name="icon-posts"
            height="5%"
            width="5%"
            className="mr1"
            style={{ minWidth: 12, minHeight: 12 }}
          />
          <span>{totalPosts}</span>
        </div>
        <Button
          color="primary"
          disabled={buttonInfo.disabled}
          className="min-w-60 mt2"
          raised
          onClick={joinCommunity}
        >
          {buttonInfo.buttonText}
        </Button>
      </div>
    </div>
  </li>
);

VerticalCard.propTypes = {
  banner: PropTypes.string,
  logo: PropTypes.string,
  name: PropTypes.string.isRequired,
  organization: PropTypes.string.isRequired,
  totalPosts: PropTypes.number.isRequired,
  totalUsers: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  joinCommunity: PropTypes.func.isRequired,
  buttonInfo: PropTypes.object.isRequired,
};

VerticalCard.defaultProps = {
  banner: '',
  logo: '',
};

export default CSSModules(VerticalCard, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Communities/Components/VerticalCard/index.jsx